import ApiService from './api-service';
import ApiError from '../util/ApiError';

const AdminService = {
  async getOrganisations() {
    const body = {
      query: `
        query {
          user {
            allOrganisations {
              Name
              name
              ShortCode
              CountryCode
              createdAt
              accountingSoftware
              subscription {
                isInTrial
                planOffline {
                  name
                }
              }
              pendingDeletion
            }
          }
        }
      `,
    };

    const data = await ApiService.meEndpoint().post('/', body);
    return data.user.allOrganisations;
  },

  async joinOrganisation(ShortCode) {
    const body = {
      query: `mutation($ShortCode: String!) {
        joinOrganisation(ShortCode: $ShortCode)
      }`,
      variables: {
        ShortCode,
      },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    if (!data.joinOrganisation) throw new ApiError('Organisation not found', { log: false });
    return true;
  },

  async leaveOrganisation(ShortCode) {
    const body = {
      query: `mutation($ShortCode: String!) {
        leaveOrganisation(ShortCode: $ShortCode)
      }`,
      variables: {
        ShortCode,
      },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.leaveOrganisation;
  },

  async deleteOrganisation(ShortCode) {
    const body = {
      query: `mutation($ShortCode: String!) {
        deleteOrganisation(ShortCode: $ShortCode)
      }`,
      variables: {
        ShortCode,
      },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.deleteOrganisation;
  },

  async assignOwnerOfOrganisation(ShortCode, newOwnerId) {
    const body = {
      query: `mutation($ShortCode: String!, $newOwnerId: String!) {
        assignOwnerOfOrganisation(ShortCode: $ShortCode, newOwnerId: $newOwnerId)
      }`,
      variables: {
        ShortCode,
        newOwnerId,
      },
    };
    const data = await ApiService.meEndpoint().post('/', body);
    return data.assignOwnerOfOrganisation;
  },
};

export default AdminService;
